import React, { useEffect, useRef } from "react";
import upArrow from "../../assets/images/organisationProfile/setup/select arrow.svg";
import upArrowdark from "../../assets/images/organisationProfile/setup/selectArowdark.svg";

import { countries, employees } from "../../constants/setup/countries";

import "./selection.scss";
// import Button from "components/Button/index";
import useTheme from "hooks/observer";

export default function Selections({
  selectedEmployee,
  setSelectedEmployee,
  sessionStorage,
  setSelectedCountry,
  selectedCountry,
  employeeDropdownOpen,
  countryDropdownOpen,
  setEmployeeDropdownOpen,
  setCountryDropdownOpen
}) {

  const theme = useTheme();

  useEffect(() => {
    const handleBeforeUnload = () => {
      sessionStorage.clear();
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const employeeDropdownRef = useRef(null);
  const countryDropdownRef = useRef(null);

  const arrow = theme === "light" ? upArrow : upArrowdark;

  const toggleEmployeeDropdown = () =>
    setEmployeeDropdownOpen(!employeeDropdownOpen);
  const toggleCountryDropdown = () =>
    setCountryDropdownOpen(!countryDropdownOpen);

  const handleEmployeeSelect = (employee) => {
    sessionStorage.setItem("selectEmployee", employee);
    setSelectedEmployee(employee);
    setEmployeeDropdownOpen(false);
  };

  const handleCountrySelect = (country) => {
    sessionStorage.setItem("selectCountry", country);
    setSelectedCountry(country);
    setCountryDropdownOpen(false);
  };

  const getSelectedStyle = (selectedValue, item) => {
    return selectedValue === item
      ? {
        color: "var(--text-grey-strong)",
        fontSize: "16px",
        fontWeight: "600",
        lineHeight: "24px"
      }
      : {};
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        employeeDropdownOpen &&
        employeeDropdownRef.current &&
        !employeeDropdownRef.current.contains(event.target)
      ) {
        setEmployeeDropdownOpen(false);
      }
      if (
        countryDropdownOpen &&
        countryDropdownRef.current &&
        !countryDropdownRef.current.contains(event.target)
      ) {
        setCountryDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [employeeDropdownOpen, countryDropdownOpen]);

  return (
    <>
      <section className="Selections">
        <div className="SelectionsWrapper">
          <div className="SelectionsForm">
            {/* <div className="form-group">
              <label htmlFor="employeeSelect" className="form-label">
                Company size
              </label>
              <div
                id="employeeSelect"
                className="form-select country-select"
                onClick={toggleEmployeeDropdown}
                ref={employeeDropdownRef}
              >
                <span>{selectedEmployee}</span>
                <img src={arrow} alt="select" />
                {employeeDropdownOpen && (
                  <div className="dropdownList employeedropDown">
                    {employees.map((employee, index) => (
                      <div
                        key={index}
                        className="dropdownItem"
                        onClick={() => handleEmployeeSelect(employee)}
                        style={getSelectedStyle(selectedEmployee, employee)}
                      >
                        {employee}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div> */}

            <div className="form-group">
              <label htmlFor="countrySelect" className="form-label">
                Location
              </label>
              <div
                id="countrySelect"
                className="form-select"
                onClick={toggleCountryDropdown}
                ref={countryDropdownRef}
              >
                <span>{selectedCountry}</span>
                <img src={arrow} alt="select" />
                {countryDropdownOpen && (
                  <div
                    className="dropdownList countryDropdown"
                    id="countryDropdown"
                  >
                    {countries.map((country, index) => (
                      <div
                        key={index}
                        className="dropdownItem"
                        onClick={() => handleCountrySelect(country)}
                        style={getSelectedStyle(selectedCountry, country)}
                      >
                        {country}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* <Button
            type="violet"
            title="Next"
            onClick={() => setChange("pricing")}
          /> */}
        </div>
      </section>
    </>
  );
}
